import {Children, RequestStatus} from "interfaces";
import {
  EmptyUIState,
  ErrorUIState,
  ErrorUIStateProps,
  EmptyUIStateProps,
} from "components/@system";
import {JSX} from "react";

interface ComponentLoaderProps extends Children<any> {
  skeleton: JSX.Element;
  errorUI?: ErrorUIStateProps;
  requestStatus: RequestStatus;
  emptyUI?: Omit<EmptyUIStateProps, "children">;
}

export const ComponentLoader: React.FC<ComponentLoaderProps> = ({
  emptyUI,
  children,
  skeleton,
  requestStatus,
}) => {
  const {success, error} = requestStatus;

  return success ? (
    typeof emptyUI !== "undefined" ? (
      <EmptyUIState {...emptyUI}>{children}</EmptyUIState>
    ) : (
      children
    )
  ) : error ? (
    <ErrorUIState />
  ) : (
    skeleton
  );
};
